import { createTheme } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";

export const themes = {
  default: createTheme(
    {
      palette: {
        primary: { main: "#1976d2" },
        secondary: { main: "#dc004e" },
        background: { default: "#fff8e1" },
        text: { primary: "#000" },
        error: { main: "#dc004e" },
        warning: { main: "#ff9501" },
        info: { main: "#2196f3" },
        success: { main: "#4caf50" },
      },
      // Você pode customizar mais tokens aqui
    },
    ptBR
  ),

  gscemi: createTheme(
    {
      palette: {
        primary: { main: "#1e395a" },
        secondary: { main: "#74a4cf" },
        background: { default: "#fff" },
        text: { primary: "#000" },
        error: { main: "#ff0000" },
        warning: { main: "#ff9501" },
        info: { main: "#0000ff" },
        success: { main: "#00ff00" },
      },
      // Você pode customizar mais tokens aqui
    },
    ptBR
  ),
  sisfuner: createTheme(
    {
      palette: {
        primary: { main: "#1e395a" },
        secondary: { main: "#74a4cf" },
        background: { default: "#fff" },
        text: { primary: "#000" },
        error: { main: "#ff0000" },
        warning: { main: "#ff9501" },
        info: { main: "#0000ff" },
        success: { main: "#00ff00" },
      },
    },
    ptBR
  ),
};
